import { forwardRef } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_INPUT_CLASS,
  TInputGroupInputProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";

export const InputGroupInput = forwardRef<HTMLInputElement, TInputGroupInputProps>(
  (
    {
      className,
      error,
      type = "text",
      "aria-invalid": ariaInvalid,
      ...props
    },
    ref,
  ) => (
    <input
      {...props}
      ref={ref}
      type={type}
      aria-invalid={error || ariaInvalid || undefined}
      data-component="InputGroupInput"
      className={cn(INPUT_GROUP_INPUT_CLASS, className)}
    />
  ),
);

InputGroupInput.displayName = "InputGroupInput";
